import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { InternalService } from 'src/app/shared/services/internal.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  userId: any;
  userProfile: any = [];

  constructor(
    public apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    public internalService: InternalService
  ) { }

  ngOnInit(): void {
    this.userId = this.route.snapshot.params.id;
    this.GetProfile();
  }

  GetProfile() {
    this.apiService.getProfile(this.userId).subscribe((res: any) => {
      console.log(res)
      this.userProfile = res.res;
      console.log(this.userProfile)
      if (this.userProfile.profilePic) {
        this.internalService.getMd5(this.userProfile.profilePic).then(result => {
          this.userProfile.profilePic = result;
        })
      }
      for ( let confirm of this.userProfile.technicnianInfo.confirmations) {
        if (confirm.icon) {
          this.internalService.getMd5(confirm.icon).then(result => {
            confirm.icon = result
          })
        }
      }
      for (let skill of this.userProfile.technicnianInfo.skills) {
        if (skill.icon) {
          this.internalService.getMd5(skill.icon).then(result => {
            skill.icon = result;
          })
        }
        
        for (let pic of skill.pictures) {
            if (pic.imageMD5) {
              this.internalService.getSkillMd5(pic.imageMD5).then(result => {
                pic.imageMD5 = result;
              })
              
            }
        }
      }

    })
  }

}
